import { MultiSelectDropdown } from "../MultiSelectDropdown";

/**
 * Filter bar for the Officers page. All state is lifted — this is a pure
 * controlled component so the parent can share the same filter state with
 * the table/grid renderers.
 */
export function GuardsFilters({
  nameOptions, nameFilter, setNameFilter,
  roleOptions, roleFilter, setRoleFilter,
  statusOptions, statusFilter, setStatusFilter,
  expiredOnly, setExpiredOnly,
  visibleCount, totalCount,
}) {
  const hasAny = nameFilter.length || roleFilter.length || statusFilter.length || expiredOnly;
  const clearAll = () => {
    setNameFilter([]); setRoleFilter([]); setStatusFilter([]); setExpiredOnly(false);
  };
  return (
    <div className="flex flex-wrap items-end gap-3" data-testid="guards-filters">
      <div>
        <div className="label-mute mb-1">Name</div>
        <MultiSelectDropdown
          testId="filter-name"
          label="All "
          options={nameOptions}
          selected={nameFilter}
          onChange={setNameFilter}
          searchable
          triggerClassName="min-w-[220px]"
          emptyHint="No  match"
        />
      </div>
      <div>
        <div className="label-mute mb-1">Role</div>
        <MultiSelectDropdown
          testId="filter-role"
          label="All roles"
          options={roleOptions}
          selected={roleFilter}
          onChange={setRoleFilter}
          triggerClassName="min-w-[160px]"
        />
      </div>
      <div>
        <div className="label-mute mb-1">Status</div>
        <MultiSelectDropdown
          testId="filter-status"
          label="All statuses"
          options={statusOptions}
          selected={statusFilter}
          onChange={setStatusFilter}
          triggerClassName="min-w-[170px]"
        />
      </div>
      {hasAny > 0 && (
        <button
          data-testid="clear-guard-filters"
          onClick={clearAll}
          className="text-xs uppercase tracking-widest text-zinc-500 hover:text-[#FF3B30] pb-2"
        >
          Clear filters
        </button>
      )}
      <label
        data-testid="filter-expired-certs"
        className={`inline-flex items-center gap-2 px-3 py-1.5 border cursor-pointer text-xs uppercase tracking-widest transition-colors ${expiredOnly ? "border-[#FF3B30] text-[#FF3B30] bg-[#FF3B30]/5" : "border-[#27272A] text-zinc-500 hover:text-white hover:border-zinc-500"}`}
      >
        <input
          type="checkbox"
          className="accent-[#FF3B30]"
          checked={expiredOnly}
          onChange={(e) => setExpiredOnly(e.target.checked)}
        />
        Expired certs
      </label>
      <div className="ml-auto text-xs font-mono text-zinc-500 pb-2">
        {visibleCount} / {totalCount} officers
      </div>
    </div>
  );
}
